import { React, useRef, useState, useEffect } from "react";

import logo from "../Images/logo.webp";

import "./new-register.css";
import "./new-redeemption.css";

import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

// import ReCAPTCHA from "react-google-recaptcha";
import UserformService from "../services/userform.service";

import $ from "jquery";

import { toast } from "react-toastify";
import { useLayoutEffect } from "react";
import "select2/dist/css/select2.min.css";
import "select2";

function RegisterForm(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Registration Form";
  const [fields, setFields] = useState({
    sales_name: "",
    store_location: "",
    name: "",
    lname: "",
    emailid: "",
    address: "",
    // p_address: "",
    city: "",
    state: "",
    zipcode: "",
    age: "",
    phone: "",
    question1: "",
    question2: "",
    question3: [],
    question3_other: "",
    question4: [],
    question5: "",
    i_agree: "",
    // captcha: "",
  });

  const [errors, setErrors] = useState({});
  // const [captcha, setCaptcha] = useState(false);
  const [states, setStates] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const [value_userform, setValue_userform] = useState([]);

  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");
  useEffect(() => {
    async function getStates() {
      let errors = {};

      try {
        const response = await UserformService.getStates();

        var states = response.data.response;
        const results = [];
        states.map((value) => {
          return results.push({
            value: value.code,
            label: value.name,
          });
        });
        await setStates([...results]);

        errors["voucher"] = response.data.response;
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    getStates();

    async function getLocations() {
      let errors = {};

      try {
        const response = await UserformService.getStoreLocation();

        var locations = response.data.response;
        const results = [];
        locations.map((value) => {
          return results.push({
            value: value.id,
            label: value.store_name,
          });
        });
        await setLocations([...results]);

        errors["voucher"] = response.data.response;
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    getLocations();
  }, []);
  const ref = useRef();

  const pasted = (e) => {
    e.preventDefault();
    return false;
  };

  const onlyNumbers = (evt) => {
    const { name, value } = evt.target;
    evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: evt.target.value,
      };
    });
  };

  const handleChange = (e) => {
    let { value, name, checked } = e.target;
    if (name === "state" && value === "true") {
      value = "";
    }

    setFields((prevValue) => {
      // ✅ Handle array type questions (question3 & question4)
      if (["question3", "question4"].includes(name)) {
        let updatedValues = [...prevValue[name]];

        if (checked) {
          if (!updatedValues.includes(value)) {
            updatedValues.push(value);
          }
        } else {
          updatedValues = updatedValues.filter((val) => val !== value);
        }

        return {
          ...prevValue,
          [name]: updatedValues,
        };
      }

      if (name === "state" && value === "true") {
        value = "";
      }

      // ✅ Handle all other fields normally
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const saveErrors = (err) => {
    setErrors(err);
  };

  const submituserRegistrationForm = (e) => {
    e.preventDefault();
    let data = {
      sales_name: fields?.sales_name,
      store_id: fields?.store_location,
      first_name: fields?.name,
      last_name: fields?.lname,
      email: fields?.emailid,
      // address1: fields?.address,
      // address2: fields?.p_address,
      city: fields?.city,
      state: fields?.state,
      zip: fields?.zipcode,
      phone: fields?.phone,
      age: fields?.age,
      question1: fields?.question1,
      question2: fields?.question2,
      question3: fields?.question3,
      question3_other: fields?.question3_other,

      question4: fields?.question4,
      question5: fields?.question5,
      i_agree: fields?.i_agree,

      // captcha: captcha,
    };

    try {
      setLoading(true);
      const responseuserform = UserformService.regData(data);
      responseuserform
        .then((response) => {
          var valueUserform = response?.data?.status;
          setValue_userform(valueUserform);

          secureLocalStorage.setItem(
            "registerform",
            JSON.stringify({
              sales_name: fields.sales_name,
              store_location: fields.store_location,
              name: fields.name,
              lname: fields.lname,
              emailid: fields.emailid,
              // address: fields.address,
              // p_address: fields.p_address,
              city: fields.city,
              state: fields.state,
              zipcode: fields.zipcode,
              phone: fields.phone,
              age: fields?.age,
              question1: fields?.question1,
              question2: fields?.question2,
              question3: fields?.question3,
              question3_other: fields?.question3_other,
              i_agree: fields?.i_agree,

              question4: fields?.question4,
              question5: fields?.question5,
              // captcha: captcha,
            })
          );
          localStorage.removeItem("return_page");
          localStorage.setItem("isRegister", true);
          navigate("/register/registration-thankyou");

          if (value_userform?.includes("redirect")) {
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);

          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            toast.error(err?.response?.data?.message, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }

          let errorData = {};
          errorData["sales_name"] =
            err?.response?.data &&
            err?.response?.data.sales_name &&
            err?.response?.data.sales_name[0];
          errorData["store_location"] =
            err?.response?.data &&
            err?.response?.data.store_id &&
            err?.response?.data.store_id[0];
          errorData["name"] =
            err?.response?.data &&
            err?.response?.data.first_name &&
            err?.response?.data.first_name[0];
          errorData["lname"] =
            err?.response?.data &&
            err?.response?.data.last_name &&
            err?.response?.data.last_name[0];
          errorData["emailid"] =
            err?.response?.data &&
            err?.response?.data.email &&
            err?.response?.data.email[0];
          // errorData["address"] =
          //   err?.response?.data &&
          //   err?.response?.data.address1 &&
          //   err?.response?.data.address1[0];
          // errorData["p_address"] =
          //   err?.response?.data &&
          //   err?.response?.data.address2 &&
          //   err?.response?.data.address2[0];
          errorData["city"] =
            err?.response?.data &&
            err?.response?.data.city &&
            err?.response?.data.city[0];
          errorData["state"] =
            err?.response?.data &&
            err?.response?.data.state &&
            err?.response?.data.state[0];
          errorData["zipcode"] =
            err?.response?.data &&
            err?.response?.data.zip &&
            err?.response?.data.zip[0];
          errorData["age"] =
            err?.response?.data &&
            err?.response?.data.age &&
            err?.response?.data.age[0];
          errorData["phone"] =
            err?.response?.data &&
            err?.response?.data.phone &&
            err?.response?.data.phone[0];
          errorData["question1"] =
            err?.response?.data &&
            err?.response?.data.question1 &&
            err?.response?.data.question1[0];
          errorData["question2"] =
            err?.response?.data &&
            err?.response?.data.question2 &&
            err?.response?.data.question2[0];
          errorData["question3"] =
            err?.response?.data &&
            err?.response?.data.question3 &&
            err?.response?.data.question3[0];
          errorData["question4"] =
            err?.response?.data &&
            err?.response?.data.question4 &&
            err?.response?.data.question4[0];
          errorData["question5"] =
            err?.response?.data &&
            err?.response?.data.question5 &&
            err?.response?.data.question5[0];
          errorData["i_agree"] =
            err?.response?.data &&
            err?.response?.data.i_agree &&
            err?.response?.data.i_agree[0];
          errorData["question3_other"] =
            err?.response?.data &&
            err?.response?.data.question3_other &&
            err?.response?.data.question3_other[0];
          errorData["checkederrortwo"] =
            err?.response?.data &&
            err?.response?.data.size &&
            err?.response?.data.size[0];
          errorData["checkederrorcaptcha"] =
            err?.response?.data &&
            err?.response?.data.captcha &&
            err?.response?.data.captcha[0];

          saveErrors(errorData);
          setTimeout(() => {
            ref?.current?.focus();
          }, 200);
        });
    } catch (err) {
      alert(err);
      if (err.response.status === 429 || err.response.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
      let errorData = {};
      errorData["sales_name"] = err?.response?.data?.sales_name[0];
      errorData["store_location"] = err?.response?.data?.store_id[0];
      errorData["name"] = err?.response?.data?.first_name[0];
      errorData["lname"] = err?.response?.data?.last_name[0];
      errorData["emailid"] = err?.response?.data?.phone[0];
      // errorData["address"] = err?.response?.data?.address1[0];
      // errorData["p_address"] = err?.response?.data?.address2[0];
      errorData["city"] = err?.response?.data?.city[0];
      errorData["state"] = err?.response?.data?.state[0];
      errorData["age"] = err?.response?.data?.age[0];
      errorData["phone"] = err?.response?.data?.phone[0];
      errorData["zipcode"] = err?.response?.data?.zip[0];

      errorData["checkederrorcaptcha"] =
        err?.response?.data?.message.captcha[0];
      saveErrors(errorData);
    }
  };

  // function onCaptchaChange(value) {
  //   if (value === null) {
  //     setCaptcha(false);
  //   } else {
  //     setCaptcha(true);
  //   }
  // }

  const Select2Field = ({ name, label, options, value }) => {
    const selectRef = useRef();

    useLayoutEffect(() => {
      const $select = $(selectRef.current);

      $select.select2();

      $select.on("change", (event) => {
        const selectedValue = $(event.target).val();
        setFields((prevValue) => {
          return {
            ...prevValue,
            [name]: selectedValue,
          };
        });
      });

      return () => {
        $select.select2("destroy");
        $select.off("change");
      };
    }, []);

    return (
      <>
        <select
          ref={selectRef}
          name={name}
          className="form-select register-select2"
          value={value || ""}
          id={name}
        >
          <option value="" disabled={true} selected={true}>
            Select {label}
          </option>
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </>
    );
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <section className="form-body-center form-section-bg new-register">
        <div className="container">
          <div className="row gy-4 align-items-center">
            <div className="col-12 col-md-12 col-xl-12">
              <div className="register-logo">
                <img
                  src={logo}
                  alt="city-logo.png"
                  className="img-fluid"
                  width="360"
                  height="118"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-xl-12">
              <div className="d-flex justify-content-center text-bg-primary top-bg">
                <div className="col-12 col-xl-12 text-center">
                  <h2 className="form-heading">
                    Register Customer for a Chance to Win!
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-12 col-xl-12">
              <div className="card border-0 rounded-4 p-0">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <form
                    onSubmit={submituserRegistrationForm}
                    name="userRegistrationForm"
                  >
                    <div className="row gy-3 overflow-hidden">
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-circle icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="sales_name"
                            placeholder="Sales Person's Name"
                            ref={errors.sales_name ? ref : null}
                            value={fields.sales_name || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Sales Person's Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">{errors.sales_name}</div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-pin icon-position"></i>

                          <Select2Field
                            name="store_location"
                            label="Location"
                            options={locations}
                            value={fields["store_location"] || ""}
                          />

                          <label className="form-label form-label-select">
                            Store Location
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.store_location && !errors.sales_name
                            ? errors.store_location
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-o icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="name"
                            placeholder="First Name"
                            ref={
                              errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            value={fields.name || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            First Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.name
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <i className="zmdi zmdi-account-o icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            name="lname"
                            style={
                              errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Last Name"
                            value={fields.lname || ""}
                            ref={
                              errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Last Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.lname
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-email-open icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            name="emailid"
                            ref={
                              errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            style={
                              errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Email"
                            value={fields.emailid || ""}
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Email (we will not send marketing emails to you)
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.emailid
                            : null}
                        </div>
                      </div>

                      {/* <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-store  icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            name="address"
                            style={
                              errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            value={fields.address || ""}
                            ref={
                              errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Address
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.address
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-store icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Apartment/Suite #"
                            name="p_address"
                            value={fields.p_address || ""}
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Apartment/Suite # (Optional)
                          </label>
                        </div>
                      </div> */}

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-city  icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="City"
                            name="city"
                            value={fields.city || ""}
                            style={
                              errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            ref={
                              errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name_l &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            City<span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.city
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-my-location icon-position"></i>

                          <Select2Field
                            name="state"
                            label="State"
                            options={states}
                            value={fields["state"] || ""}
                          />

                          <label className="form-label form-label-select">
                            State<span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.state
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-smartphone-code  icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Zip Code"
                            name="zipcode"
                            maxLength="10"
                            style={
                              errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            value={fields.zipcode || ""}
                            ref={
                              errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Zip Code<span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.zipcode &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.zipcode
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-calendar icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Age"
                            name="age"
                            onKeyUp={onlyNumbers}
                            onPaste={pasted}
                            style={
                              errors.age &&
                              !errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            value={fields.age || ""}
                            ref={
                              errors.age &&
                              !errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Age<span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.age &&
                          !errors.zipcode &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.age
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-local-phone icon-position"></i>

                          <input
                            type="text"
                            name="phone"
                            style={
                              errors.phone &&
                              !errors.age &&
                              !errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            className="form-control"
                            placeholder="Phone Number"
                            value={fields.phone || ""}
                            ref={
                              errors.phone &&
                              !errors.age &&
                              !errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                            onKeyUp={onlyNumbers}
                            onPaste={pasted}
                            maxLength={10}
                          />

                          <label className="form-label">
                            Phone Number
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.phone &&
                          !errors.zipcode &&
                          !errors.age &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.phone
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-thumb-up icon-position"></i>

                          <input
                            type="text"
                            name="question1"
                            style={
                              errors.question1 &&
                              !errors.age &&
                              !errors.phone &&
                              !errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            className="form-control"
                            placeholder="Answer"
                            value={fields.question1 || ""}
                            ref={
                              errors.question1 &&
                              !errors.age &&
                              !errors.phone &&
                              !errors.zipcode &&
                              !errors.state &&
                              !errors.city &&
                              // !errors.address &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.name &&
                              !errors.store_location &&
                              !errors.sales_name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Which Serta did you like most?
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.question1 &&
                          !errors.zipcode &&
                          !errors.age &&
                          !errors.phone &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.question1
                            : null}
                        </div>
                      </div>

                      <div className="col-md-12  col-sm-12 mb-0 mt-0">
                        <fieldset className="checkbox-group small-checkbox">
                          <legend className="checkbox-group-legend">
                            Did you know Regency's Serta mattresses are proudly
                            made in Landover, Maryland?
                            <span className="text-danger"> *</span>
                          </legend>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question2"
                                className="checkbox-input"
                                value="Yes"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">Yes</span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question2"
                                className="checkbox-input"
                                value="No"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">No</span>
                              </span>
                            </label>
                          </div>
                        </fieldset>
                        <div className="errorMsg">
                          {errors.question2 &&
                          !errors.question1 &&
                          !errors.zipcode &&
                          !errors.age &&
                          !errors.phone &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.question2
                            : null}
                        </div>
                      </div>
                      <div className="col-md-12  col-sm-12 mb-0">
                        <fieldset className="checkbox-group small-checkbox">
                          <legend className="checkbox-group-legend">
                            When choosing a mattress, what are your top two
                            priorities? (Select 2 that apply)
                            <span className="text-danger"> *</span>
                          </legend>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Comfort & Contouring"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes(
                                    "Comfort & Contouring"
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Comfort & Contouring
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Support for back"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes(
                                    "Support for back"
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Support for back
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Appearance & Style"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes(
                                    "Appearance & Style"
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Appearance & Style
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Temperature Regulation (cooling or warming features)"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes(
                                    "Temperature Regulation (cooling or warming features)"
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Temperature Regulation (cooling or warming
                                  features)
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Motion isolation (reduces partner's movement)"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes(
                                    "Motion isolation (reduces partner's movement)"
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Motion isolation (reduces partner's movement)
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Durability (resists dipping, sagging, and premature breakdown)"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes(
                                    "Durability (resists dipping, sagging, and premature breakdown)"
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Durability (resists dipping, sagging, and
                                  premature breakdown)
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question3"
                                className="checkbox-input"
                                value="Other"
                                onChange={handleChange}
                                disabled={
                                  fields?.question3?.length === 2 &&
                                  !fields?.question3?.includes("Other")
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Other (please specify)
                                </span>
                              </span>
                            </label>
                          </div>
                          {fields?.question3?.includes("Other") && (
                            <>
                              <div className="form-floating w-100 mt-3 mb-0">
                                <i className="zmdi zmdi-comments icon-position"></i>

                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Others"
                                  name="question3_other"
                                  onChange={handleChange}
                                  value={fields.question3_other || ""}
                                  style={
                                    errors.question3_other &&
                                    !errors.question1 &&
                                    !errors.question1 &&
                                    !errors.question2 &&
                                    !errors.question3 &&
                                    !errors.zipcode &&
                                    !errors.age &&
                                    !errors.phone &&
                                    !errors.state &&
                                    !errors.city &&
                                    // !errors.address &&
                                    !errors.emailid &&
                                    !errors.lname &&
                                    !errors.name &&
                                    !errors.store_location &&
                                    !errors.sales_name
                                      ? { border: "1px solid red" }
                                      : null
                                  }
                                  ref={
                                    errors.question3_other &&
                                    !errors.question1 &&
                                    !errors.question1 &&
                                    !errors.question2 &&
                                    !errors.question3 &&
                                    !errors.zipcode &&
                                    !errors.age &&
                                    !errors.phone &&
                                    !errors.state &&
                                    !errors.city &&
                                    // !errors.address &&
                                    !errors.emailid &&
                                    !errors.lname &&
                                    !errors.name &&
                                    !errors.store_location &&
                                    !errors.sales_name
                                      ? ref
                                      : null
                                  }
                                />

                                <label className="form-label">
                                  Others
                                  <span className="gl-form-asterisk"></span>
                                </label>
                              </div>
                              <div className="errorMsg">
                                {errors.question3_other &&
                                !errors.question1 &&
                                !errors.question1 &&
                                !errors.question2 &&
                                !errors.question3 &&
                                !errors.zipcode &&
                                !errors.age &&
                                !errors.phone &&
                                !errors.state &&
                                !errors.city &&
                                // !errors.address &&
                                !errors.emailid &&
                                !errors.lname &&
                                !errors.name &&
                                !errors.store_location &&
                                !errors.sales_name
                                  ? errors.question3_other
                                  : null}
                              </div>
                            </>
                          )}
                        </fieldset>
                        <div className="errorMsg">
                          {errors.question3 &&
                          !errors.question1 &&
                          !errors.question2 &&
                          !errors.zipcode &&
                          !errors.age &&
                          !errors.phone &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.question3
                            : null}
                        </div>
                      </div>

                      <div className="col-md-12  col-sm-12 mb-0">
                        <fieldset className="checkbox-group small-checkbox">
                          <legend className="checkbox-group-legend">
                            When selecting a particular brand of mattresses, I
                            consider the following: (Select up to 2 that apply)
                            <span className="text-danger"> *</span>
                          </legend>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="It was recommended by family or friends."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "It was recommended by family or friends."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  It was recommended by family or friends.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="It was recommended by one or more review sites online."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "It was recommended by one or more review sites online."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  It was recommended by one or more review sites
                                  online.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="I've purchased the brand in the past and/or slept on a mattress by the brand before."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "I've purchased the brand in the past and/or slept on a mattress by the brand before."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  I've purchased the brand in the past and/or
                                  slept on a mattress by the brand before.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="I frequently see the brand's advertisements."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "I frequently see the brand's advertisements."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  I frequently see the brand's advertisements.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="The brand has been in the market for a long time."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "The brand has been in the market for a long time."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  The brand has been in the market for a long
                                  time.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="The brand appeals to my vibe, personality, and style."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "The brand appeals to my vibe, personality, and style."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  The brand appeals to my vibe, personality, and
                                  style.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                name="question4"
                                className="checkbox-input"
                                value="Brand doesn't matter to me."
                                onChange={handleChange}
                                disabled={
                                  fields?.question4?.length === 2 &&
                                  !fields?.question4?.includes(
                                    "Brand doesn't matter to me."
                                  )
                                }
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  Brand doesn't matter to me.
                                </span>
                              </span>
                            </label>
                          </div>
                        </fieldset>
                        <div className="errorMsg">
                          {errors.question4 &&
                          !errors.question1 &&
                          !errors.question2 &&
                          !errors.question3 &&
                          !errors.question3_other &&
                          !errors.zipcode &&
                          !errors.age &&
                          !errors.phone &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.question4
                            : null}
                        </div>
                      </div>
                      <div className="col-md-12  col-sm-12 mb-0">
                        <fieldset className="checkbox-group small-checkbox">
                          <legend className="checkbox-group-legend">
                            When did you buy your last mattress for yourself?
                            (Select one):
                            <span className="text-danger"> *</span>
                          </legend>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question5"
                                className="checkbox-input"
                                value="< 1 year ago"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  {"<"} 1 year ago
                                </span>
                              </span>
                            </label>
                          </div>

                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question5"
                                className="checkbox-input"
                                value="1-3 years ago"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  1-3 years ago
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question5"
                                className="checkbox-input"
                                value="3-5 years ago"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  3-5 years ago
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question5"
                                className="checkbox-input"
                                value="5-10 years ago"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  5-10 years ago{" "}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="question5"
                                className="checkbox-input"
                                value="10+ years ago"
                                onChange={handleChange}
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-label">
                                  10+ years ago
                                </span>
                              </span>
                            </label>
                          </div>
                        </fieldset>
                        <div className="errorMsg">
                          {errors.question5 &&
                          !errors.question1 &&
                          !errors.question2 &&
                          !errors.question4 &&
                          !errors.question3 &&
                          !errors.question3_other &&
                          !errors.zipcode &&
                          !errors.age &&
                          !errors.phone &&
                          !errors.state &&
                          !errors.city &&
                          // !errors.address &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.name &&
                          !errors.store_location &&
                          !errors.sales_name
                            ? errors.question5
                            : null}
                        </div>
                      </div>

                      <div className="col-md-12 col-sm-12 mb-0">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="i_agree"
                            id="myCheck"
                            onChange={handleChange}
                          />
                          <label className="form-check-label" htmlFor="myCheck">
                            I confirm I completed a test rest on a Serta
                            mattress, am least 18 years of age, and understand
                            the terms and conditions (below).
                          </label>
                          <div className="errorMsg">
                            {errors.i_agree &&
                            !errors.question1 &&
                            !errors.question2 &&
                            !errors.question4 &&
                            !errors.question3 &&
                            !errors.question5 &&
                            !errors.zipcode &&
                            !errors.age &&
                            !errors.phone &&
                            !errors.question3_other &&
                            !errors.state &&
                            !errors.city &&
                            // !errors.address &&
                            !errors.emailid &&
                            !errors.lname &&
                            !errors.name &&
                            !errors.store_location &&
                            !errors.sales_name
                              ? errors.i_agree
                              : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-sm-12 mt-1">
                        <div className="form-check">
                          <label className="form-check-label">
                            <strong> Terms & Conditions:</strong> <br />
                            No purchase necessary. One (1) eligible participant
                            will be randomly selected to receive a $300 gift
                            card for completing a “test rest” on a Serta®
                            mattress during the promotional period. To enter,
                            participants must register via the provided promo
                            URL or QR code and confirm that they completed a
                            test rest on a Serta mattress. Only one entry per
                            person. Promotion runs from September 20, 2025
                            through September 28, 2025. The winner will be
                            selected at random, similar to a lottery, and
                            notified via the contact information provided at
                            registration. The prize will be fulfilled by Elite
                            Rewards, a Serta partner, and issued in the form of
                            a digital gift card via email within 30 days after
                            the event end date. Eligibility is subject to
                            verification. Misrepresentation of participation
                            will result in disqualification. Odds of winning
                            depend on the total number of eligible entries
                            received. Must be at least 18 years or older to
                            qualify. Void where prohibited. Serta 2025.
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-5 col-sm-12 ">
                        <div className="d-grid">
                          <button
                            className="btn btn-primary btn-lg "
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="alert alert-info alert-info-custom">
                          Limit 1 per household, while supplies last. Some
                          restrictions apply, see store for detail.
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>

      {/* <Footer2 /> */}
    </>
  );
}
export default RegisterForm;
